import React from 'react';
import business from '../../style/images/e-business.png';
import kipa from '../../style/images/Kipa-logo.svg';

const Header = () => {
 return (
     <header>
        <div className='e-business'>
            <img src={business} className='shaparak-logo' alt='business'/>
        </div>
         <div className='kipa'>
            <h2 className='header-title'>پرداخت اعتباری و اقساطی کیپا</h2>
         </div>
         <div className='kipa-logo'>
             <img src={kipa} className='shaparak-logo' alt='kipaa'/>
         </div>
     </header>
 )
};
export default Header;